// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobPreviewLocationDetail-base__nA8b2{display:flex;gap:var(--size-2);align-items:flex-start;align-self:stretch;color:var(--gray-11)}.JobPreviewLocationDetail-locationAddress__PaK2u{margin-bottom:var(--size-0);font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "JobPreviewLocationDetail-base__nA8b2",
	"locationAddress": "JobPreviewLocationDetail-locationAddress__PaK2u"
};
export default ___CSS_LOADER_EXPORT___;
